import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const token = tokenService.getToken();
  const refreshToken = tokenService.getRefreshToken();
  let reqClone;
  if (req.url.includes('/refresh')) {
    reqClone = req.clone({
      headers: req.headers.set(
        'Authorization',
        refreshToken ? `Bearer ${refreshToken}` : ''
      ),
    });
  } else {
    reqClone = req.clone({
      headers: req.headers.set('Authorization', token ? `Bearer ${token}` : ''),
    });
  }

  return next(reqClone).pipe(
    catchError((error) => {
      if (error.status === 401 && !isRefreshing) {
        isRefreshing = true;

        return tokenService.getNewAccessToken().pipe(
          switchMap((response: any) => {
            isRefreshing = false;
            tokenService.saveToken(response.access_token);

            const newReq = req.clone({
              headers: req.headers.set(
                'Authorization',
                `Bearer ${response.access_token}`
              ),
            });

            return next(newReq);
          }),
          catchError((refreshError) => {
            isRefreshing = false;
            localStorage.removeItem('token');
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
